import { NEW_ROUTEMAP } from '@/constants/routes';
import {
    TAP_BTN_HOME,
    TAP_BTN_BUY_CAR,
    TAP_BTN_SERVICE_CAR,
    TAP_BTN_SELL_CAR,
    TAP_BTN_ARTICLES,
} from '@/analytics/events';

const AD_FRONT_APP_HOST = process.env.NEXT_PUBLIC_AD_FRONT_APP_HOST || '';

export const navigationItems = [
    {
        href: AD_FRONT_APP_HOST,
        inactiveIcon: '/icons/bottomNavigation/Home-Inactive.svg',
        activeIcon: '/icons/bottomNavigation/Home-Active.svg',
        label: 'Home',
        actionName: TAP_BTN_HOME,
    },
    {
        href: `${AD_FRONT_APP_HOST}cars/`,
        inactiveIcon: '/icons/bottomNavigation/Car-Inactive.svg',
        activeIcon: '/icons/bottomNavigation/Car-Active.svg',
        label: 'New Car',
        actionName: TAP_BTN_BUY_CAR,
    },
    {
        href: '/',
        inactiveIcon: '/icons/bottomNavigation/Service-Inactive.svg',
        activeIcon: '/icons/bottomNavigation/Service-Active.svg',
        label: 'Service',
        actionName: TAP_BTN_SERVICE_CAR,
    },
    {
        href: `${AD_FRONT_APP_HOST}used/car-valuation/`,
        inactiveIcon: '/icons/bottomNavigation/Sell-Inactive.svg',
        activeIcon: '/icons/bottomNavigation/Sell-Active.svg',
        label: 'Sell',
        actionName: TAP_BTN_SELL_CAR,
    },
    {
        href: `${AD_FRONT_APP_HOST}news/`,
        inactiveIcon: '/icons/bottomNavigation/Blog-Inactive.svg',
        activeIcon: '/icons/bottomNavigation/Blog-Active.svg',
        label: 'News',
        actionName: TAP_BTN_ARTICLES,
    },
];
